<template>
  <div>
    <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" />
    <div id="app">
      <van-tabs v-model="active" color="#FFCFB3" @change="getRepayList">
        <van-tab title="Not Yet Repaid">
        </van-tab>
        <van-tab title="Paid-Up"></van-tab>
      </van-tabs>
      <div class="repayment-box" v-for="item in repayList" :key="item.order_id">
        <div class="repayment-title flex flex-justify-between flex-align-center">
          <div class="font-20 font-weight-bold">
            {{ item.product_name }}
          </div>
          <div class="font-weight-500 white repayment-btn font-14" v-if="active === 0"
            @click="repaymentdetails(item.order_id)">
            Repay Now
          </div>
        </div>
        <div class="repayment-content ">
          <div class="flex flex-justify-between flex-align-center" style="padding: 0px  40px;">
            <div class="text-center">
              <div class="font-16 font-weight-bold">
                {{ item.all_amount }}
              </div>
              <div class="font-12 clr_777777">
                Repayment Amount
              </div>
            </div>
            <div class="text-center">
              <div class="font-16 font-weight-bold">
                {{ item.cycle }}
              </div>
              <div class="font-12 clr_777777">
                final time
              </div>
            </div>
          </div>
          <van-divider />
          <div class="font-10 clr_777777 text-center">
            {{ item.remark }}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      repayList: [],
      active: 0
    }
  },
  created() {
    this.getRepayList()
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async getRepayList() {
      const { data: res } = await this.$http.post('/api/product/repayList', { type: this.active })
      if (res.code === 0) {
        this.repayList = res.data.rows
      } else {
        this.$toast(res.msg)
      }
    },
    repaymentdetails(order_id) {
      this.$router.push({
        name: 'repaymentdetails',
        query: {
          order_id: order_id
        }
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #F9F9F9;
  min-height: 100vh;
  padding: 12px 12px 0px 12px;
  box-sizing: border-box;

  .repayment-box {
    border-radius: 14px 14px 0px 0px;
    padding: 20px 12px;

    .repayment-title {
      background: #C0BFFF;
      padding: 13px 14px;
      border-radius: 14px 14px 0px 0px;
    }

    .repayment-content {
      border-radius: 0px 0px 14px 14px;
      background: #FFFFFF;
      padding: 14px 19px;
    }

    .repayment-btn {
      border-radius: 18px;
      background: #726AFF;
      padding: 7px 11px;
    }
  }


}
</style>
